import * as React from "react";

export const DefaultLogoUrl = '/icons/chatbotlogo.webp';

export interface IInitialState { 
  screenView: ScreenView;
  chatOpened: boolean;
  welcomeMessage: boolean;
  subscribedChat: boolean;
  webChatDto: WebChatDTO; 
  webchatHeight: number;
  messageHeight: number;
  message: string;
  messages: TicketMessageDTO[];
  webChatSettings: WebChatSettingsDTO;
  isThinking: boolean;
}

export enum ScreenView {
  Welcome = 10,
  Chat = 20,
  VoiceChat = 30
}

export enum TicketPriority {
  High = 10,
  Medium = 20,
  Low = 30
}

export enum TicketStatus {
  Open = 10,
  Pending = 20,
  Resolved = 30,
  Closed = 40,
  WaitingForCustomer = 50,
  WaitingOnThirdParty = 60,
  Deleted = 70,
  Spam = 80,
  Inbox = 90
}

export enum TicketOrigin {
  WebForm = 10,
  Email = 20,
  Telegram = 30
}

export enum UserType {
  StaffUser = 10,
  Customer = 20,
  Anonymous = 30
}

export enum TicketResponseMessageSender {
  HelpDesk = 10,
  Customer = 20,
  System = 30,
  Internal = 40,
  Anonymous = 50
}

export enum TicketResponseType
{
    Note = 10,
    Response = 20,
    SystemMessage = 30,
    File = 40
}

export class TicketDTO {
    Id: number = 0;
    Title: string = '';
    Description: string = '';
    Priority: TicketPriority = TicketPriority.Low;
    Status: TicketStatus = TicketStatus.Open;
    CreateDate: string = '';
    TicketResponseMessages: TicketMessageDTO[] = [];
    Origin: TicketOrigin = TicketOrigin.WebForm;
    UserType: UserType = UserType.Anonymous;
}

export class TicketMessageDTO {
  Id: number = 0;
  MessageText: string = '';
  Content: string = '';
  Attachment: string = '';
  CreateDate: string = '';
  MessageSenderType: TicketResponseMessageSender = TicketResponseMessageSender.Anonymous;
  TicketId: number = 0;
  TicketResponseType: TicketResponseType = TicketResponseType.Response;
  Status: TicketStatus = TicketStatus.Open;
}

export class PromptDTO {
  Id: number = 0;
  Title: string = '';
  Prompt: string = '';
}


export class TicketCategoryDTO {
  id: number = 0;
  categoryName: string = '';
  orderNo: number = 0;
}

export enum WebChatStatus {
  New = 0,
  Active = 10,
  Closed = 20
}

/**
 * Data transfer object representing a web chat session.
 * @property {string} Session - Unique identifier for the chat session.
 * @property {string} Lang - Language code for the chat conversation.
 * @property {TicketDTO} Ticket - Associated ticket information.
 * @property {WebChatStatus} Status - Current status of the web chat.
 * @property {boolean} ForceOpen - Flag indicating if chat should remain open.
 * @property {string} CreateDate - ISO date string when chat was created.
 * @property {string} LastUpdatedDate - ISO date string of last chat update.
 */
export class WebChatDTO {
  Session: string = '';
  Lang: string = '';
  Ticket: TicketDTO = new TicketDTO();
  Status: WebChatStatus = WebChatStatus.New;
  ForceOpen: boolean = false;
  CreateDate: string = '';
  LastUpdatedDate: string = '';
}

export enum WebchatPosition {
  Middle = 1,
  Left = 2,
  Right = 3,
  Draggable = 4
}

export enum WebchatLogoPosition {
  Middle = 1,
  Left = 2,
  Right = 3
}

export class WebChatSettingsDTO {
  Application: string = '';
  WebchatPosition: WebchatPosition = WebchatPosition.Right; 
  LogoPosition: WebchatLogoPosition = WebchatLogoPosition.Right; 
  MainColour: string = '';
  IconUrl: string = DefaultLogoUrl;
  LogoUrl: string = DefaultLogoUrl;
  AssistantIconUrl: string = DefaultLogoUrl;
  PrimaryTextColour: string = '';
  SecondaryTextColour: string = '';
  CssUrl: string = '';
  WelcomeTitle: string = '';
  WelcomeSubTitle: string = '';
  StartChatTitle: string = '';
  StartChatSubTitle: string = '';
  InitialPrompts: PromptDTO[] = [];
  IsVoiceChatEnabled: boolean = false;
  VoiceChatbotVoiceName: string = '';
  VoiceChatbotLanguage: string = '';
  VoiceChatbotPrompt: string = '';
  ChatBotApiUrl: string = '';
  ChatBotApiAccessToken: string = '';
  BranchId: number | null = null;
}

export class WebChatUpdateRequest {
  Session: string = '';
  Message: string = '';
  Attachment: string | null = null;
}

//export class WebChatCloseRequest {
//  session: string;
//  closeWebChat: boolean;
//}

//export class HubTicketConnectionDetails {
//  url: string;
// 
//  token: string;
//}

export const initialState: IInitialState = { 
  screenView: ScreenView.Welcome, 
  chatOpened: false,
  welcomeMessage: true,
  subscribedChat: false,
  webChatDto: new WebChatDTO(),
  webchatHeight: 500,
  messageHeight: 56,
  message: '',
  messages: [],
  webChatSettings: new WebChatSettingsDTO(),
  isThinking: false
};

export const DataContext = React.createContext<IInitialState>(initialState);